import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { CrossAccountGrantOfGranter, useRevokeGrantByIdMutation } from '../../store/crossAccount/crossAccount'

interface DeleteGrantModalProps {
  grant?: CrossAccountGrantOfGranter
  show: boolean
  onHide: () => void
}

export const DeleteGrantModal: React.FC<DeleteGrantModalProps> = ({ grant, show, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const [revokeGrant, revokeGrantResult] = useRevokeGrantByIdMutation()
  const handleRevokeGrant = async () => {
    if (grant) {
      revokeGrant({ accountId: accountId, grantId: grant.id })
    }
  }

  useEffect(() => {
    if (revokeGrantResult.isSuccess) {
      onHide()
    }
  }, [revokeGrantResult])

  if (!grant) {
    return null
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Grant</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete cross-account grant of <b>{grant.granteeDisplayName}</b> ?
          </div>
        </Col>
      </Row>
      <Row></Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleRevokeGrant}
      footerPrimaryActionLoading={revokeGrantResult.isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    ></Modal>
  )
}
